var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRemoveHeader = function SvgRemoveHeader(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.35622 3.35622C3.83118 2.88126 4.60125 2.88126 5.07621 3.35622L12 10.28L18.9238 3.35622C19.3988 2.88126 20.1688 2.88126 20.6438 3.35622C21.1187 3.83118 21.1187 4.60125 20.6438 5.07621L13.72 12L20.6438 18.9238C21.1187 19.3988 21.1187 20.1688 20.6438 20.6438C20.1688 21.1187 19.3988 21.1187 18.9238 20.6438L12 13.72L5.07621 20.6438C4.60125 21.1187 3.83118 21.1187 3.35622 20.6438C2.88126 20.1688 2.88126 19.3988 3.35622 18.9238L10.28 12L3.35622 5.07621C2.88126 4.60125 2.88126 3.83118 3.35622 3.35622Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRemoveHeader, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/remove_header.aa6e3838.svg";
export { ForwardRef as ReactComponent };